import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent, ZoomMediaSelectedEvent } from '@theme/events';

export class MediaGallery extends Component {
  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, { signal });
    this.refs.zoomDialogComponent?.addEventListener(ThemeEvents.zoomMediaSelected, this.#handleZoomMediaSelected, {
      signal,
    });

    setTimeout(() => {
      const slideshow = this.querySelector('slideshow-component');
      if (slideshow) {
        slideshow.addEventListener('slideshow:select', this._handleSlideSelect.bind(this), { signal });
      }
    }, 500);
  }

  #controller = new AbortController();

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  #handleVariantUpdate = (event) => {
    const source = event.detail.data.html;
    if (!source) return;

    const featuredMediaId = event.detail.resource?.featured_media?.id;

    if (featuredMediaId) {
      const slideshow = this.refs.slideshow;
      if (!slideshow) return;

      const slides = Array.from(
        slideshow.querySelectorAll('slideshow-slide:not([hidden])')
      );

      const targetIndex = slides.findIndex(
        (slide) => slide.querySelector('[data-media-id]')?.dataset.mediaId == featuredMediaId
      );

      if (targetIndex !== -1) {
        slideshow.select(targetIndex, undefined, { animate: false });
        return;
      }
    }

    const newMediaGallery = source.querySelector('media-gallery');
    if (!newMediaGallery) return;
    this.replaceWith(newMediaGallery);
  };

  _handleSlideSelect(event) {
    const slide = event.detail?.slide;
    if (!slide) return;

    const variantId = slide.dataset?.variantId;
    if (!variantId) return;

    const section = this.closest('.shopify-section');
    if (!section) return;

    const variantPicker = section.querySelector('variant-picker');
    if (!variantPicker) return;

    const variantInput = section.querySelector(`input[data-variant-id="${variantId}"]`);
    if (!variantInput || !(variantInput instanceof HTMLInputElement)) return;

    const currentVariantId = variantPicker.selectedOption?.dataset?.variantId;
    if (currentVariantId === variantId) return;

    variantInput.click();
  }

  #handleZoomMediaSelected = async (event) => {
    this.slideshow?.select(event.detail.index, undefined, { animate: false });
  };

  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }

  get slideshow() {
    return this.refs.slideshow;
  }

  get media() {
    return this.refs.media;
  }

  get presentation() {
    return this.dataset.presentation;
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}